import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const AZURE_PUBLIC_CLIENT_APP = new PublicClientApplication({
  auth: {
    clientId: environment.azureConf.clientId,
    authority: `${environment.azureConf.cloudInstance}/${environment.azureConf.tenantInfo}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
  },
});

export const AZURE_AUTH_REQUEST: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: ['openid', 'profile'],
  },
};

export const AZURE_PROTECTED_RESOURCE_MAP: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
  protectedResourceMap: new Map([
    [`${environment.apiBasePath}/*`, [`api://${environment.azureConf.clientId}/CaseEntry`]],
  ]),
};
